<!-- 卡片类型 -->
<template>
    <div class="cardtype">
        <div class="type_zuo type_bian" v-if="offsetnum>9"><img :src="themeUrlLeft" @click="GoLeft"></div>
        <div class="type_itemlist" ref="itemlist" @scroll="handleScroll">
            <div class="type_item" :class="isSeaItem===index?'item_sea':''" v-for="i,index in typelist" :key="index" @click="SealItem(i.id,index)">
                <div>{{ i.name }}</div>
            </div>
        </div>
        <div class="type_you type_bian" v-if="!isScrolledToRight"><img :src="themeUrlRight" @click="GoRight"></div>
    </div>
</template>

<script setup>
import {onMounted,computed, ref, watch, watchEffect} from 'vue'
import { useStore} from 'vuex'
import {GetTabgrade,GetItem} from "@/api"

const store = useStore()
const isScrolledToRight = ref(false)
const offsetnum = ref(0)
const offsetWidth = ref(0)
const typelist = ref()
const isSeaItem = ref(0)
const itemlist = ref(null)
let paramObj = {
    pageNum:1,
    pageSize:100,
    type:null,
    name:null,
    isHop:false,
    state:1
}
const itemlist1 = ref([])


onMounted(()=>{
    GetTabgrade({type:3}).then(res=>{
        typelist.value = res
        typelist.value = typelist.value.filter(i=>{return i.state===1})
        SealItem(typelist.value[0].id,0)
    }).catch()
})

// 向左滚动
const GoLeft = ()=>{
    smoothScroll(itemlist.value,offsetnum.value-150,100)
    offsetnum.value -=150
}

// 向右滚动
const GoRight = ()=>{
    smoothScroll(itemlist.value,offsetnum.value+150,100)
    offsetnum.value +=150

}

const handleScroll = (event)=>{
    const container = event.target;
    isScrolledToRight.value = container.scrollWidth - Math.round(container.scrollLeft) -1 === container.clientWidth || container.scrollWidth - Math.round(container.scrollLeft) === container.clientWidth;
}

onMounted(()=>{
    offsetWidth.value = itemlist.value.offsetWidth
})

// 丝滑滚动div
const smoothScroll = (element, to, duration)=>{
    if (duration <= 0) return;
    
    var difference = to - element.scrollLeft;
    var step = difference / duration * 10;

    requestAnimationFrame(function() {
    element.scrollLeft += step;
    if (Math.abs(difference) > 1) {
        smoothScroll(element, to, duration - 10);
    }
    });
}

// 左边箭头图片
const themeUrlLeft = computed(()=>{
    if(store.state.app.theme===1){
        return require('@/assets/left_while.svg')
    }else if(store.state.app.theme===2){
        return require('@/assets/left_black.svg')
    }
})
// 右边箭头图片
const themeUrlRight = computed(()=>{
    if(store.state.app.theme===1){
        return require('@/assets/right_while.svg')
    }else if(store.state.app.theme===2){
        return require('@/assets/right_black.svg')
    }
})


const SealItem = (type,num)=>{
    isSeaItem.value = num
    paramObj.type = type
    GetItem(paramObj).then(res=>{
        itemlist1.value = res.records
        itemlist1.value.forEach(i => {
            i.picurl = process.env.VUE_APP_PIC_URL + i.picurl
            i.typelist = i.typelist.split('，')
        });
        store.commit('app/SET_ITEMLIST',itemlist1.value)
    }).catch()
}
</script>

<style lang="scss" scoped>
div::-webkit-scrollbar{display:none}
.cardtype{
    padding: 2rem 3rem;
    padding-right: 9rem;
    width: 100%;
    // left: 4rem;
    // transform: translateX();
    display: flex;
    background: var(--cardtype-list-bac);
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
    .type_bian{
        width: 3rem;
        height: inherit;
        position: absolute;
        display: flex;
        cursor: pointer;
        z-index: 2;
        img{
            width: 1.5rem;
            height: 3rem;
        }
    }
    .type_zuo{
        background: var(--cardtype-left-bac);
    }
    .type_you{
        right: 7rem;
        background: var(--cardtype-right-bac);
        justify-content: flex-end;
    }
    .type_itemlist{
        display: flex;
        align-items: center;
        overflow: hidden;
        position: relative;
        // width: 97%;
        scrollbar-width: none;
        // transform: ;
        transition: all 1s;
        .type_item{
            cursor: pointer;
            text-align: center;
            font-size: .9rem;
            padding: 0px 1rem;
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
            transition: opacity 1s ease-in-out;
            >div{
                font-weight: 500;
                white-space: nowrap;
                border: 1px solid var(--cardtype-list-item-border1);
                background: var(--cardtype-list-item-bac);
                border-radius: 50vw;
                padding: .7rem 1.5rem;
                color: #b0b0b0;
                // background-color: #f0efef;
            }
        }
        .type_item:hover{
            >div{
                color:var(--cardtype-list-item-hover);
                border:1px solid var(--cardtype-list-item-hover);
            }
        }
        .item_sea{
            >div{
                background: var(--cardtype-list-item-sea-bac);
                color:var(--cardtype-list-item-sea-color);
            }
            &.type_item:hover{
                >div{
                    color:var(--cardtype-list-item-sea-hover);
                }
            }
        }
    }
}
</style>